// extracted by mini-css-extract-plugin
module.exports = {"ldsHeart":"style-module--lds-heart--2Mk5N"};